var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 51,
    viewBox: "0 0 62 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7352 12.5363L29.4327 26.1169C29.8899 25.9862 30.4119 25.921 30.9343 25.921C31.5218 25.921 32.0442 25.9862 32.5014 26.1169L34.2644 12.5363V12.079C34.2644 10.2509 32.7628 8.81445 30.9998 8.81445C30.0857 8.81445 29.1716 9.20613 28.5841 9.92435C27.931 10.7082 27.6045 11.6222 27.7352 12.5362L27.7352 12.5363Z",
    fill: "#4BB543"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9999 28.5977C29.1718 28.5977 27.7354 30.0992 27.7354 31.8622C27.7354 33.6904 29.2369 35.192 30.9999 35.192C32.8281 35.192 34.3297 33.6904 34.3297 31.8622C34.3297 30.0997 32.8281 28.5977 30.9999 28.5977Z",
    fill: "#4BB543"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1645 10.9036C52.7421 3.85219 42.0341 0 30.9999 0C19.9657 0 9.2579 3.85207 0.835326 10.9036C-0.143857 11.687 -0.274567 13.1234 0.508776 14.103L29.2369 50.1438C29.6942 50.6662 30.3468 50.9927 30.9999 50.9927C31.7182 50.9927 32.3713 50.6662 32.7629 50.1438L61.4911 14.103C62.2744 13.1234 62.1442 11.6869 61.1645 10.9036H61.1645ZM30.9999 44.9857L5.47101 12.993C12.7835 7.50861 21.7938 4.50498 30.9999 4.50498C40.206 4.50498 49.2162 7.50861 56.5288 12.993L30.9999 44.9857Z",
    fill: "#4BB543"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/offline.b55af2fab0698f0b1ac2eb7373e249cd.svg";
export { ForwardRef as ReactComponent };